import { render, staticRenderFns } from "./Taobao-dis.vue?vue&type=template&id=033a4a3d&"
import script from "./Taobao-dis.vue?vue&type=script&lang=js&"
export * from "./Taobao-dis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports